(function () {
  function getSelectedControl(productInfoEl) {
    const checkedRadio = productInfoEl.querySelector('variant-selects input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio;

    const selectedOption = productInfoEl.querySelector('variant-selects select option:checked');
    if (selectedOption) return selectedOption;

    return null;
  }

  function shouldShowPreorderMessage(control) {
    if (!control) return false;

    const isZeroStock = control.dataset.aaZeroStock === 'true';
    const inventoryPolicy = control.dataset.aaInventoryPolicy || '';

    return isZeroStock && inventoryPolicy === 'continue';
  }

  function updatePreorderMessage(productInfoEl) {
    const preorderMessageEl = productInfoEl.querySelector('[data-aa-preorder-message]');
    if (!preorderMessageEl) return;

    const selectedControl = getSelectedControl(productInfoEl);
    preorderMessageEl.hidden = !shouldShowPreorderMessage(selectedControl);
  }

  function runUpdate(productInfoEl) {
    updatePreorderMessage(productInfoEl);

    setTimeout(function () {
      updatePreorderMessage(productInfoEl);
    }, 30);

    setTimeout(function () {
      updatePreorderMessage(productInfoEl);
    }, 100);
  }

  function initProductInfo(productInfoEl) {
    if (!productInfoEl || productInfoEl.dataset.aaPreorderInit === 'true') return;
    productInfoEl.dataset.aaPreorderInit = 'true';

    productInfoEl.addEventListener('change', function () {
      runUpdate(productInfoEl);
    });

    productInfoEl.addEventListener('click', function (event) {
      if (
        event.target.closest('label') ||
        event.target.closest('.swatch-input__label') ||
        event.target.closest('input[type="radio"]')
      ) {
        runUpdate(productInfoEl);
      }
    });

    runUpdate(productInfoEl);
  }

  function initAll(scope) {
    scope.querySelectorAll('product-info').forEach(initProductInfo);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();